import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { useAuth } from "../../context/AuthContext";
import { apiError } from "../../lib/api";
import { LogoMark } from "../../components/Logo";
import { Field, Input, Btn } from "./AdminKit";

export default function Login() {
  const { signIn } = useAuth();
  const nav = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      await signIn(email, password);
      toast.success("Welcome back.");
      nav("/admin");
    } catch (err) {
      toast.error(apiError(err));
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-nead-ink px-4">
      <div className="w-full max-w-sm">
        <div className="flex items-center gap-3 mb-8 justify-center">
          <LogoMark className="h-10 w-10" />
          <span className="font-display font-bold text-2xl text-white tracking-tight">NEAD Admin</span>
        </div>
        <form onSubmit={submit} className="rounded-2xl bg-white p-8 shadow-2xl" data-testid="admin-login-form">
          <h1 className="font-display font-bold text-xl text-nead-navy">Sign in</h1>
          <p className="mt-1 text-sm text-nead-navy/55">Manage events, news and hire.</p>
          <div className="mt-6 space-y-4">
            <Field label="Email">
              <Input type="email" required value={email} onChange={(e) => setEmail(e.target.value)} placeholder="you@nead.uk" data-testid="admin-login-email" />
            </Field>
            <Field label="Password">
              <Input type="password" required value={password} onChange={(e) => setPassword(e.target.value)} placeholder="••••••••" data-testid="admin-login-password" />
            </Field>
            <Btn type="submit" disabled={busy} className="w-full" data-testid="admin-login-submit">{busy ? "Signing in…" : "Sign in"}</Btn>
          </div>
        </form>
      </div>
    </div>
  );
}
